module.exports = __webpack_public_path__ + "img/undraw_shared_workspace_hwky.4c4e1717.svg";